import React, { Component, PropTypes } from 'react';
import { v4 } from 'node-uuid';

export default class Specializations extends Component {
  render() {
    const { specializations } = this.props;

    if (!specializations || !specializations.length) {
      return null;
    }

    return (
            <div className="profile-languages">
              <h4>Specializations</h4>
              { specializations.map(specialization => (
                <span key={v4()} className="tag tag-default tag-sm language-tag">
                  { specialization.name }
                </span>))
              }
            </div>
          );
  }
}

Specializations.propTypes = {
  specializations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
  }))
};



// WEBPACK FOOTER //
// ./profile/components/specializations.jsx